import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserChosenMunicipio, USER_CHOSEN_MUNICIPIO_EVENT } from '../services/userChosenMunicipio';

/**
 * Resolve o "contexto de município" para navegação.
 * Prioridade: slug na URL > município escolhido (localStorage).
 * Retorna { slug, basePath } — basePath é '' quando não há município.
 */
export default function useMunicipioBasePath() {
  const { municipioSlug } = useParams();
  const [chosenSlug, setChosenSlug] = useState(() => getUserChosenMunicipio()?.slug || null);

  useEffect(() => {
    const onChange = () => setChosenSlug(getUserChosenMunicipio()?.slug || null);
    window.addEventListener(USER_CHOSEN_MUNICIPIO_EVENT, onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener(USER_CHOSEN_MUNICIPIO_EVENT, onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);

  const slug = municipioSlug || chosenSlug || null;
  return { slug, basePath: slug ? `/${slug}` : '' };
}
